<template>
	<div class="alert df wao hao" v-if="has">
		<div class="box">
			<div class="cap">{{option.title}}</div>
			<div class="txt" v-if="option.message">{{option.message}}</div>
			<div class="df war" v-if="!option.isConfirm">
				<div class="btn" @click="tapBtn(1)">{{option.btn}}</div>
			</div>
			<div class="df war" v-else>
				<div class="btn2" @click="tapBtn(1)">{{option.btn}}</div>
				<div class="btn2" @click="tapBtn(2)" v-if="option.isConfirm">{{option.btn2}}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'alert',
	data () {
		return {
			has: false,
			option: {
				isConfirm: 0,
				title: '',
				message: '',
				btn: null,
				btnCall: null,
				btn2: null,
				btnCall2: null,
			},
		}
	},
	methods: {
		tapBtn(type){
			this.has = false
			if(type==1){
				this.option.btnCall && this.option.btnCall()
			}else{
				this.option.btnCall2 && this.option.btnCall2()
			}
		},
	},
}
</script>

<style lang="less" scoped>
	.alert{
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		z-index: 9995;
		background: rgba(0, 0, 0, 0.4);

		.box{
			background: #FFFFFF;
			box-shadow: 0px 9px 28px 8px rgba(0,0,0,0.05), 0px 6px 16px 0px rgba(0,0,0,0.08), 0px 3px 6px -4px rgba(0,0,0,0.12);
			border-radius: 4px 4px 4px 4px;
			position: relative;
			width: 416px;
			padding: 32px 32px 24px 32px ;
			.cap{
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 16px;
				color: #000000;
				line-height: 24px;
				background: url(../../assets/img/imp.png) left center / 22px auto no-repeat;
				padding-left: 38px;
			}
			.txt{
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: rgba(0,0,0,0.85);
				line-height: 22px;
				padding-left: 38px;
				margin-top: 8px;
				span{
					color: #7F7F7F;
				}
			}
			.btn{
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 16px;
				color: #FFFFFF;
				line-height: 42px;
				width: 116px;
				background: #009B73;
				box-shadow: 0px 2px 0px 0px rgba(0,0,0,0.04);
				border-radius: 2px;
				text-align: center;
				margin-top: 24px;
			}
			
			.btn2{
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #FFFFFF;
				line-height: 32px;
				width: 60px;
				background: #009B73;
				box-shadow: 0px 2px 0px 0px rgba(0,0,0,0.04);
				border-radius: 2px;
				text-align: center;
				margin-top: 24px;
				margin-left: 8px;
				cursor: pointer;
				&:last-child{
					background: #fff;
					color: rgba(0,0,0,0.85);
					border-radius: 2px 2px 2px 2px;
					border: 1px solid #D9D9D9;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/alert/alert.vue